// extracted by mini-css-extract-plugin
module.exports = {"Picture":"Image_Picture__P3vQt","Image":"Image_Image__K6uPV"};